import { createContext, useState } from "react";

interface GenerateInvoiceActionContextType {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  generatePdf: boolean;
  setGeneratePdf: (generate: boolean) => void;
  sendToCustomer: boolean;
  setSendToCustomer: (send: boolean) => void;
  separatedInvoices: boolean;
  setSeparatedInvoices: (separated: boolean) => void;
}

export const GenerateInvoiceActionContext = createContext<GenerateInvoiceActionContextType>({
  showModal: false,
  setShowModal: () => {},
  loading: false,
  setLoading: () => {},
  generatePdf: true,
  setGeneratePdf: () => {},
  sendToCustomer: false,
  setSendToCustomer: () => {},
  separatedInvoices: true,
  setSeparatedInvoices: () => {},
});

export const GenerateInvoiceActionProvider: React.FC<{ children: any }> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [generatePdf, setGeneratePdf] = useState(true);
  const [sendToCustomer, setSendToCustomer] = useState(false);
  const [separatedInvoices, setSeparatedInvoices] = useState(true);

  return (
    <GenerateInvoiceActionContext.Provider value={{ 
      showModal, 
      setShowModal, 
      loading, 
      setLoading,
      generatePdf,
      setGeneratePdf,
      sendToCustomer,
      setSendToCustomer,
      separatedInvoices,
      setSeparatedInvoices
    }}>
      {children}
    </GenerateInvoiceActionContext.Provider>
  );
};
